<template>
  <div>
    <p v-if="date() != ''">Published on {{ date() }}</p>
  </div>
</template>

<script>
export default {
  name: 'CIS-ResourcePublishedDate',
  props: {
    publishedAt: {
      type: Object
    }
  },
  methods: {
    date() {
      const date = new Date(this.publishedAt.value);

      const dateOptions = {
        weekday: undefined,
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
      };

      const newDate =
        date?.toLocaleDateString(undefined, dateOptions) === 'January 1, 1'
          ? ''
          : date?.toLocaleDateString(undefined, dateOptions);

      return newDate;
    }
  }
};
</script>
<style lang="scss">
p.byline {
  font-weight: 500;
}
</style>
